<img
  [class.white]="isWhite"
  [src]="isWhite ? '/assets/sdk/gelato-logo-white.svg' : '/assets/sdk/gelato-logo-black.svg'"
/>
